export const fiTranslation = {
  // People
  peopleTitle: "Henkilöt",
  all: "Kaikki",
  employees: "Työntekijät",
  contractors: "Urakoitsijat",
  visitors: "Vierailijat",
  employee: "Työntekijä",
  contractor: "Urakoitsija",
  visitor: "Vierailija",
  firstName: "Etunimi",
  lastName: "Sukunimi",
  email: "Sähköposti",
  company: "Työnantaja",
  phoneNumber: "Puhelinnumero",
  taxNumber: "Veronumero",
  userType: "Käyttäjän tyyppi",
  dateOfBirth: "Syntymäaika",
  addPerson: "+ Lisää henkilö",
  deletePerson: "- Poista henkilö",
  deleteConfirmation: "Haluatko varmasti poistaa kyseiset henkilöt?",
  deletePartConfirmation: "Haluatko varmasti poistaa tämän?",
  cannotRemoveManager: "Ylläpitäjää ei voi poistaa.",
  invitePeople: "Kutsu henkilö:",
  inviteToCourse: "Kutsu kurssille",
  readedTos: "Olen lukenut ja hyväksyn",
  tos: "käyttöehdot",
  personalInformation: "Henkilötiedot",
  occupationalSafetyCard: "Työturvakortin numero",
  hotWorkCard: "Tulityökortin numero",
  occupationalSafetyCardImage: "Työturvakortin kuva",
  firstAidCardImage: "Ensiapukortin kuva",
  hotWorkCardImage: "Tulityökortin kuva",
  shoeSize: "Ulkokengän koko",
  jacketSize: "Takin koko (Unisex: S / M / L / XL / XXL)",
  dietaryRestrictions: "Erityisruokavalio (valinnainen)",
  visitationDate: "Vierailupäivä",
  search: "Etsi...",
  density: "Koko",
  small: "Pieni",
  medium: "Keskikokoinen",
  large: "Suuri",
  columns: "Sarakkeet",
  filter: "Haku",
  export: "Vie",
  saveAndInvite: "Tallenna ja kutsu",
  savedImage: "Kuva tallennettu",
  addUser: "Uusi osallistuja",
  requireNewUserCreation: "Käyttäjän luonti QR-koodilla",
  verificationCode: "Vahvistuskoodi",
  checkVerificationCode: "Tarkista vahvistuskoodi",
  askToVerify: "Syötä sähköpostiisi lähetetty vahvistuskoodi jatkaaksesi koulutukseen.",
  askToVerifySpam: "Jos viesti ei saavu muutaman minuutin kuluessa, tarkista myös roskapostikansio.",
  askToVerifySupport: " Tekninen tuki +358409123514",
  willSendVerificationCode: "Lähetämme sähköpostiisi vahvistuskoodin tilisi varmentamiseksi.",
  sendVerificationCode: "Lähetä vahvistuskoodi",
  emailInUse: "Tällä osoitteella on jo luotu käyttäjä",
  phoneInUse: "Tällä puhelinnumerolla on jo luotu käyttäjä",
  // Courses
  coursesTitle: "Kurssit",
  courses: "Kurssit",
  newCourse: "+ Uusi kurssi",
  deleteCourseConfirmation: "Oletko varma että haluat poistaa tämän kurssin?",
  addSlide: "+ Lisää dia",
  backgroundImage: "Taustakuva:",
  recurrency: "Toistuva:",
  none: "Ei",
  monthly: "Kuukausittain",
  yearly: "Vuosittain",
  previousSlide: "Edellinen",
  nextSlide: "Seuraava",
  chooseLayout: "Valitse sivun tyyli",
  textOnly: "Teksti",
  leftImage: "Kuva ja teksti",
  video: "Video",
  quiz: "Kysely",
  status: "Tila",
  completed: "Suoritettu",
  name: "Nimi",
  description: "Kuvaus",
  completedDate: "Suoritettu p/k/v",
  addImage: "Lisää kuva",
  changeImage: "Vaihda kuva",
  fillMode: "Kuvan koko",
  deleteSlide: "Poista dia",
  organize: "Järjestä diat",
  moveUp: "Siirrä ylös",
  moveDown: "Siirrä alas",
  newAnswer: "+ Uusi vastaus",
  newQuestion: "+ Uusi kysymys",
  checkAnswers: "Tarkista vastaukset",
  deleteSlideConfirmation: "Haluatko varmasti poistaa tämän dian?",
  textContent: "Teksti",
  imageContent: "Kuva",
  videoContent: "Video",
  quizContent: "Kysely",
  oneElementLayout: "Yksi elementti",
  oneElementWithTitleLayout: "Yksi elementti ja otsikko",
  twoColumnsWithTitleLayout: "Kaksi elementtiä ja otsikko",
  twoColumnsLayout: "Kaksi elementtiä",
  threeElementsWithTitleLayout: "Kolme elementtiä ja otsikko",
  threeElementsLayout: "Kolme elementtiä",
  generatePublicLink: "Luo julkinen linkki esikatseluun",
  result: "Tulos",
  passed: "Hyväksytty",
  failed: "Hylätty",
  required: "Vaadittu",
  tryAgain: "Yritä uudelleen",
  howManyQuestions: "Kuinka monta kysymystä näytetään?",
  howManyCorrectAnswers: "Kuinka monta oikeaa vastausta vaaditaan?",
  send: "Lähetä",
  slides: "Diat",
  info: "Info",
  Unfinished: "Ei suoritettu",
  welcomeToCourse: "Tervetuloa suorittamaan kurssia",
  checkPassword: "Tarkista salasana",
  password: "Salasana",
  confirm: "Vahvista",
  missingFieldsTitle: "Täydennä puuttuvat tiedot",
  tosDisclaimer:
    "Ennen kurssin suorittamista sinun tulee hyväksyä käyttöehdot ja syöttää sähköpostiisi lähetetty salasana.",
  selectCourses: "Valitse kurssit joille haluat kutsua henkilöitä",
  message: "Viesti",
  messageContent: "Viesti",
  messages: "Viestit",
  includeName: "Lähetä nimellä",
  sentMessage: "Viesti lähetetty",
  messageError: "Viestin lähettämisessä tapahtui virhe, yritä uudelleen.",
  allowIncludeName: "Salli nimettömänä lähettäminen",
  selectImage: "Valitse kuva tai lisää uusi",
  selectAnImage: "Valitse kuva",
  gallery: "Galleria",
  ownImages: "Omat kuvat",
  uploadImage: "Lataa uusi kuva",
  addToGallery: "Lisää kuva galleriaan",
  addBackgroundImage: "Lisää taustakuva",
  changeBackgroundImage: "Vaihda taustakuva",
  deleteBackgroundImage: "Poista taustakuva",
  deleteFromGallery: "Poista kuva galleriasta",
  qrLabel: "QR-koodin otsikko",
  duplicateSlide: "Kopioi dia",
  requireUserTracking: "Suorittajien seuranta julkisen linkin kautta",
  askUserName: "Syötä sähköpostiosoitteesi jatkaaksesi.",
  askEmail: "Sähköposti",
  username: "Käyttäjätunnus",
  publicCourses: "Julkiset linkit:",
  allowPublicCourses: "Salli suoritusten seuranta julkisen linkin kautta",
  lastEdited: "Viimeksi muokattu: ",
  messageTitle: "Viestin otsikko",
  emailNotifications: "Sähköposti-ilmoitukset",
  notifyByEmail: "Ilmoita kurssin suorituksista sähköpostilla",
  enterEmail: "Syötä sähköposti",
  addMyEmail: "Lisää sähköpostini ilmoituslistalle",
  basic: "Perustiedot",
  newUserType: "Uusien käyttäjien tyyppi (valinnainen)",
    // Common
  errorOccured: "Tapahtui virhe",
  ok: "OK",
  cancel: "Peruuta",
  edit: "Muokkaa",
  save: "Tallenna",
  back: "Takaisin",
  logout: "Kirjaudu ulos",
  login: "Kirjaudu sisään",
  logoutConfirmation: "Kirjaudu ulos?",
  // Settings
  settings: "Asetukset",
  peopleInfo: "Käyttäjien tiedot",
  isTaxNumberVisible: "Käyttäjän veronumero",
  isPhoneVisible: "Käyttäjän puhelinnumero",
  isCompanyVisible: "Käyttäjän työnantaja",
  isSafetyCardVisible: "Käyttäjän työturvakortti",
  isHotWorkCardVisible: "Käyttäjän tulityökortti",
  isSafetyCardImageVisible: "Käyttäjän työturvakortin kuva",
  isFirstAidCardVisible: "Käyttäjän ensiapukortin kuva",
  isDateOfBirthVisible: "Käyttäjän syntymäaika",
  isHotWorkCardImageVisible: "Käyttäjän tulityökortin kuva",
  isShoeSizeVisible: "Käyttäjän kengän koko",
  isJacketSizeVisible: "Käyttäjän takin koko",
  isDietaryRestrictionsVisible: "Käyttäjän erityisruokavalio",
  isVisitationDateVisible: "Vierailupäivämäärä"
};
